export default {
  SET_LOADED(state, payload) {
    state.loaded = payload;
  },
  SET_SCORE(state, payload) {
    state.score = payload;
  },
  SET_FUEL(state, payload) {
    state.fuel = payload;
  },
  SET_LEVEL(state, payload) {
    state.level = payload;
  },
  SET_MODE(state, payload) {
    state.mode = payload;
  },
  SET_USER_DATA(state, payload) {
    state.userData = payload;
  },
  SET_SKIN(state, payload) {
    state.skin = payload;
  },
  SET_PLAYER_DISTANCE(state, payload) {
    state.playerDistance = payload;
  },
};
